import React, { useState } from "react";
import MonoButton from "./MonoButton";
import { useNavigate } from "react-router-dom";
import { PaperBG } from "../kits";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const response = await fetch("https://www.denisbitter.de/stage01/api/forgot_password_api.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage("Ein Passwort-Reset-Link wurde an deine E-Mail gesendet.");
      } else {
        setError(data.message || "Fehler beim Senden der Anfrage.");
      }
    } catch (error) {
      setError(
        <span>
          Leider ist der Server nicht erreichbar <br /> Bitte versuche es später nochmal.
        </span>
      );

    }
  };

  return (
    <PaperBG>   
    <div className="min-h-screen flex flex-col">
    <main className="flex-grow flex flex-col justify-center container mx-auto px-4 sm:px-6 py-12 gap-12">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto">
        <h2 className="text-sm font-mono text-center mb-4">
        <span className="block">Bitte setze mein Passwort zurück</span>
        
          </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
           
            <input
              type="email"
              value={email}
              placeholder="deine E-Mail"
              
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full px-4 py-2 border font-mono  text-xs rounded-md font-mono focus:outline-none focus:ring-1 focus:ring-black focus:border-black"
              required
            />
          </div>
          <MonoButton type="submit" className="w-full">Passwort vergessen</MonoButton>
        </form>
        {message && (
          <p className="mt-4 text-green-500 text-center font-bold">{message}</p>
        )}
       {error && (
  <div className="mt-6 text-center space-y-4">
    <p className="text-red-500 font-bold">{error}</p>
    <div className="w-full">
    <MonoButton onClick={() => navigate("/")}>← Zurück zur Startseite</MonoButton>
    </div>
  </div>
)}
      </div>
    </main>
  

  </div>
  </PaperBG>
  
  );
  
};

export default ForgotPassword;